"use client"

import clsx from "clsx"
import Image from "next/image"
import React, { useState, useEffect } from "react"

import PlayBtnIconWithBG from "../../../../public/icons/play-button.svg"
import VideoPlayerModal from "../VideoPlayerModel"

import type { CardBase } from "./types/card"

const CardVideo: React.FC<CardBase> = ({
  uri,
  linkClassName,
  mainImage,
  cardType,
  title,
  index,
}) => {
  const [playing, setPlaying] = useState(false)
  const handlePlayAction = () => {
    setPlaying(!playing)
  }

  useEffect(() => {
    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === "Escape" || event.key === "Esc") {
        setPlaying(false)
      }
    }

    if (playing) {
      window.addEventListener("keydown", handleEsc)
    } else {
      window.removeEventListener("keydown", handleEsc)
    }

    return () => {
      window.removeEventListener("keydown", handleEsc)
    }
  }, [playing])

  return (
    <div
      className={clsx(
        "hover:opacity-80 ease-in-out transition-all duration-300",
        linkClassName,
      )}
    >
      {playing && (
        <VideoPlayerModal
          youtubeVideoId={uri}
          toggle={handlePlayAction}
          isShowing={playing}
          title={title}
        />
      )}

      <div
        className="relative overflow-hidden rounded-lg group"
        onClick={() => {
          handlePlayAction()
        }}
        onKeyDown={() => {
          handlePlayAction()
        }}
        tabIndex={0}
        role="button"
      >
        <div className="rounded-lg aspect-video">
          <Image
            sizes="100vw"
            width={634}
            height={360}
            alt="card"
            src={mainImage}
            priority={index <= 2}
          />
        </div>
        <div className="absolute inset-0 flex items-center justify-center w-full h-full overflow-hidden bg-cover rounded cursor-pointer">
          <div
            className={clsx(
              "relative w-20 h-20 transition-all rounded-full backdrop-blur-md group-hover:scale-110",
            )}
          >
            <PlayBtnIconWithBG className={clsx("w-20 h-20")} />
          </div>
        </div>
      </div>

      <div className="p-4 mt-4">
        {cardType && (
          <p className="mb-4 text-gray-30 caption3 md:caption2">{cardType}</p>
        )}
        <h2 className="heading2 text-gray-5">{title}</h2>
      </div>
    </div>
  )
}

export default CardVideo
